<template>
  <div>
      <DashboardTemplate>
        <div v-if="getRule ==='board' ">
          <Maintenance/>
        </div>
        <DepartmentList v-else />
      </DashboardTemplate>
  </div>
</template>
/* eslint-disable */
<script>
// @ is an alias to /src
import Maintenance from "@/components/Maintenance.vue";
import DashboardTemplate from '@/template/DashboardTemplate.vue';
import DepartmentList from "@/components/DepartmentList.vue";
import { mapGetters } from "vuex";

export default {
  name: "reportBoard",
  components: {
    Maintenance,
    DepartmentList,
    DashboardTemplate,
  },
  computed: {
    getRule() {
      return this.$store.getters.getRule;
    }
  }
};
</script>
